import React from 'react';
import { roundNum } from 'utils/numbers';
import NutritionDataBlock from '../NutritionDataBlock';

const IngredientRow = props => {
  const {
    handleSelectIngredient,
    handleRemovingIngredient,
    ingredient,
    index
  } = props;

  return (
    <div className="ingredient-row">
      <div className="ingredient-title">
        <i className="fas fa-carrot"></i>
        <p
          onClick={() => {
            ingredient.index = index;
            handleSelectIngredient(ingredient);
          }}
        >
          {ingredient.name}
        </p>
      </div>
      <div className="nutrition-data">
        <NutritionDataBlock value={roundNum(ingredient.quantity_size)} label="Servings" />
        <NutritionDataBlock
          value={`${roundNum(ingredient.weight_grams)}g`}
          label="Grams"
        />
        <NutritionDataBlock value={`${roundNum(ingredient.protein)}g`} label="Protein" />
        <NutritionDataBlock value={`${roundNum(ingredient.carbs)}g`} label="Carbs" />
        <NutritionDataBlock value={`${roundNum(ingredient.fat)}g`} label="Fats" />
        <NutritionDataBlock
          value={`${roundNum(ingredient.calories)}g`}
          label="Calories"
        />
      </div>
      <div className="ingredient-delete">
        <i
          onClick={() => handleRemovingIngredient(index)}
          className="fas fa-trash"
        ></i>
      </div>
    </div>
  );
};

export default IngredientRow;
